module.exports = __webpack_public_path__ + "static/favicon-2c171741b5978ad2bc0bcd2d55834605.ico";